var axios = require('axios');
var qs = require('qs');

async function createCheckout(payload) {
    var config = {
        method: 'post',
        url: process.env.REACT_APP_ENDPOINT_V3 + '/stripe/checkout',
        headers: {
            'Content-Type': "application/json"
        },
        data: JSON.stringify({
            "amount": payload.amount,
            "currency": "eur",
            "description": payload.description,
            "type": payload.type,
        })
    };

    try {
        const res = await axios(config);
        return res.data;
    } catch (e) {
        console.error(e);

        const formData = new FormData();
        formData.append("name", "stripe.createCheckout");
        formData.append("date", new Date());
        formData.append("error", JSON.stringify(e));
        formData.append("data", JSON.stringify({
            "amount": payload.amount,
            "currency": "eur",
            "description": payload.description,
            "type": payload.type,
        }));

        const response = await axios.post('https://script.google.com/macros/s/AKfycbwCDszudF2KFAfSjVHLuaiY1zirNhR7rf_R6l49gwq6L9ct4esKSSPIfIggJ2kLySNEOw/exec',
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }
}

async function doPostTransaction(payload) {

    var data = qs.stringify({
        'type': payload.type,
        'ris_id': payload.risId,
        'order_id': payload.orderId,
        'payment_intent_id': payload.stripePaymentId,
    });

    var config = {
        method: 'post',
        url: process.env.REACT_APP_ENDPOINT_V3 + '/stripe/transactions/',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
    };

    try {
        const res = await axios(config);
        return res.data;
    } catch (e) {
        console.error(e);

        const formData = new FormData();
        formData.append("name", "stripe.doPostTransaction");
        formData.append("date", new Date());
        formData.append("error", JSON.stringify(e));
        formData.append("data", JSON.stringify({
            'type': payload.type,
            'ris_id': payload.risId,
            'order_id': payload.orderId,
            'payment_intent_id': payload.stripePaymentId,
        }));

        const response = await axios.post('https://script.google.com/macros/s/AKfycbwCDszudF2KFAfSjVHLuaiY1zirNhR7rf_R6l49gwq6L9ct4esKSSPIfIggJ2kLySNEOw/exec',
            formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }
}

const stripeClient = {
    createCheckout,
    doPostTransaction,
};
export default stripeClient;
